import React from "react";
import UserOrdersPageComponent from "./components/UserOrdersPageComponent";
import axios from "axios";
import { URL } from "../../App";

const getOrders = async () => {
  const config = {
    headers: {
      Authorization: sessionStorage.getItem("access_token") || localStorage.getItem("access_token"),
    },
  };
  const { data } = await axios.get(`${URL}/api/orders`, config);
  return data
}

const UserOrdersPage = () => {
  return (
    <UserOrdersPageComponent
      getOrders={getOrders} 
    />
  );
};

export default UserOrdersPage;
